<template>
  <div>
    <content-creation v-if="creationDialog" v-model="creationDialog" :currentContents="currentContents" :type="selectedForm" />
    <content-reordering v-if="reordererDialog" v-model="reordererDialog" :originalArray="currentContents" />
    <speed-dial v-model="speedDial" :showsReorder="showsReorder" @itemTapped="didTapAdd" />
  </div>
</template>

<script>
import ContentCreation from "./creation";
import ContentReordering from "./reordering";
import SpeedDial from "@/components/contents/SpeedDial";

export default {
  components: { ContentCreation, ContentReordering, SpeedDial },
  props: {
    showsReorder: Boolean,
    currentContents: Array
  },
  data: () => ({
    reordererDialog: false,
    creationDialog: false,
    dialogTitle: "",
    selectedForm: null,
    speedDial: false,
  }),
  methods: {
    didTapAdd(type) {
      if (type === "reorder") {
        this.reordererDialog = true;
      } else {
        this.selectedForm = type;
        this.creationDialog = true;
      }
    }
  }
};
</script>